import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { copyRoot } from "@/lib/clipboard";

export default function CopyCode({ code, size = "md", tone }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation();
    await copyRoot(code);
    setCopied(true);
    toast.success("Root copied", { description: code });
    setTimeout(() => setCopied(false), 1400);
  };

  return (
    <button
      onClick={handleCopy}
      data-testid={`copy-code-${code}`}
      title="Copy root"
      className={`group inline-flex items-center gap-2 rounded-lg border font-mono font-bold tracking-wide transition-all hover:opacity-80 active:scale-95 ${
        tone || "border-amber-500/30 bg-amber-500/10 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300"
      } ${size === "md" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs"}`}
    >
      <span className="truncate max-w-[104px] sm:max-w-[180px]">{code}</span>
      {copied ? (
        <Check className="w-4 h-4 text-emerald-600 dark:text-emerald-400 animate-bounce-once shrink-0" />
      ) : (
        <Copy className="w-4 h-4 opacity-60 group-hover:opacity-100 shrink-0" />
      )}
    </button>
  );
}
